/* eslint-disable react/prop-types */
 
import { Link } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Box } from "@mui/material";

export default function Breadcrumb({ breadcrumbData }) {
  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb">
        {breadcrumbData.map((item, index) => (
          <Box key={index}>
            {item.current ? (
              <span
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  cursor: "default",
                }}
                aria-current="page"
              >
                {item.name}
              </span>
            ) : (
              <Link
                to={item.href}
                style={{
                  "&:hover": {
                    textDecoration: "underline",
                  },
                  color: "inherit",
                  cursor: "pointer",
                }}
              >
                {item.name}
              </Link>
            )}
          </Box>
        ))}
      </Breadcrumbs>
    </div>
  );
}
